export default __webpack_public_path__ + "locales/sk/Common.json?hash=56e49b6549d3fd480ef0a9b3cdbcc79b";